import ContactForm from '../components/ContactForm.js';

function Connect() {
    return (
       <ContactForm></ContactForm>
    );
  }
  
  export default Connect;